import { SWReactIcons } from '@similarweb/icons';

import { Tooltip } from '../../../../components/Tooltip';
import { Crm } from '../../../../domain/crm';
import { useUserQuery } from '../../../../features/user/useUserQuery';
import { useIsSwUser } from '../../../../hooks/useIsSwUser';
import { translate } from '../../../../services/i18n';

import { StyledAccountOwnerContainer, StyledAccountOwnerLink, StyledAccountOwnerText } from './styles';

const crmTypeToName = {
  [Crm.salesforce]: 'Salesforce',
  [Crm.hubspot]: 'HubSpot',
};

export const AccountOwnerTooltip = ({ crm, withPadding = true }: { crm: Crm; withPadding?: boolean }) => {
  const { data } = useUserQuery();
  const isSwUser = useIsSwUser();

  const isCrmAdmin = data?.hasAccessToManageCrm;
  return (
    <StyledAccountOwnerContainer withPadding={withPadding}>
      <Tooltip
        content={
          isCrmAdmin || isSwUser ? (
            <>
              {translate('contacts.bulk.export_to_crm.preview_modal.account_owner.tooltip', {
                crm: crmTypeToName[crm],
              })}
              <StyledAccountOwnerLink href="https://pro.similarweb.com/#/sales/management" target="_blank">
                {translate('contacts.bulk.export_to_crm.preview_modal.account_owner.link')}
              </StyledAccountOwnerLink>
            </>
          ) : (
            translate('contacts.bulk.export_to_crm.preview_modal.account_owner.not_admin.tooltip', {
              admin: data?.accountAdminEmails?.join(', '),
            })
          )
        }
        placement="bottom-right"
        minWidth={230}
      >
        <SWReactIcons iconName="info" size="xs" />
      </Tooltip>
      <StyledAccountOwnerText>
        {translate('contacts.bulk.export_to_crm.preview_modal.account_owner.text')}
      </StyledAccountOwnerText>
    </StyledAccountOwnerContainer>
  );
};
